export default function logger(filename, message, data={}) {
    if(process.env.NODE_ENV === "dev" || process.env.NODE_ENV === "development") {
        console.log(`Filename :: ${filename} | Message :: ${message} | Data ::`,data);
    }
}